import * as R from 'ramda'
import { createSelector } from 'reselect'
import {
  entitiesSelector,
} from 'helpers/ComponentSelectorUtil'

import {
  employeeList,
} from 'containers/User/EmployeeList/selectors'

const userStateSelector = state => state.admin.userRoles.user
const roleStateSelector = state => state.admin.userRoles.role

const userSelector = createSelector(
  userStateSelector,
  employeeList,
  R.prop
)

export {
  userSelector,
  roleStateSelector,
  userStateSelector,
}
